// Logo "mark" con su propia paleta (no hereda currentColor) para que
// destaque siempre, sin importar el color del texto que lleva al lado.

export default function LogoMark({ size = 44, className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label="La Fábrica de los Cuentos"
      className={className}
    >
      <defs>
        <linearGradient id="lfdcBg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#6b21a8" />
        </linearGradient>
        <linearGradient id="lfdcPage" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#fdf4ff" />
        </linearGradient>
        <radialGradient id="lfdcSparkle" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%" stopColor="#fde68a" />
          <stop offset="100%" stopColor="#f59e0b" />
        </radialGradient>
        <filter id="lfdcShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="1.5" stdDeviation="1.4" floodColor="#5b21b6" floodOpacity="0.35" />
        </filter>
      </defs>

      {/* Insignia redondeada de fondo (color sólido fuerte) */}
      <rect x="2" y="2" width="44" height="44" rx="12" fill="url(#lfdcBg)" filter="url(#lfdcShadow)" />

      {/* Libro abierto centrado, blanco con sombra interior sutil */}
      <g transform="translate(0 2)">
        {/* Página izquierda */}
        <path
          d="M11 16 C14 14, 20 14, 24 16 L24 34 C20 32, 14 32, 11 34 Z"
          fill="url(#lfdcPage)"
          stroke="#e9d5ff"
          strokeWidth="0.6"
          strokeLinejoin="round"
        />
        {/* Página derecha */}
        <path
          d="M37 16 C34 14, 28 14, 24 16 L24 34 C28 32, 34 32, 37 34 Z"
          fill="url(#lfdcPage)"
          stroke="#e9d5ff"
          strokeWidth="0.6"
          strokeLinejoin="round"
        />
        {/* Lomo (línea central) */}
        <line x1="24" y1="16" x2="24" y2="34" stroke="#c084fc" strokeWidth="0.8" />
        {/* Renglones decorativos sutiles */}
        <g stroke="#d8b4fe" strokeWidth="0.7" strokeLinecap="round" opacity="0.85">
          <line x1="14" y1="20" x2="22" y2="19.2" />
          <line x1="14" y1="23" x2="22" y2="22.2" />
          <line x1="14" y1="26" x2="21" y2="25.4" />
          <line x1="26" y1="19.2" x2="34" y2="20" />
          <line x1="26" y1="22.2" x2="34" y2="23" />
          <line x1="26" y1="25.4" x2="33" y2="26" />
        </g>
      </g>

      {/* Chispa dorada arriba-derecha (toque "mágico") */}
      <g transform="translate(35 12)">
        <path
          d="M0 -5 C0.5 -1.5, 1.5 -0.5, 5 0 C1.5 0.5, 0.5 1.5, 0 5 C-0.5 1.5, -1.5 0.5, -5 0 C-1.5 -0.5, -0.5 -1.5, 0 -5 Z"
          fill="url(#lfdcSparkle)"
          stroke="#b45309"
          strokeWidth="0.4"
        />
      </g>
      {/* Mini chispa secundaria */}
      <circle cx="13.5" cy="11" r="1.4" fill="#fde68a" stroke="#f59e0b" strokeWidth="0.4" />
    </svg>
  );
}
